module.exports = __webpack_public_path__ + "portal-static/img/7.3e42a38f.jpg";